import { Typography } from "antd";
import React from "react";
import "./style.less";

const { Title } = Typography;

const Logo = () => {
  return (
    <div className="logo-wrapper">
      <div className="hrsol-icon">
        <Title level={3} style={{ color: "white" }}>
          H
        </Title>
      </div>
      <Title level={4} className="service-name">
        Hrsol Attendance
      </Title>
    </div>
  );
};

export default Logo;
